module.exports = __webpack_public_path__ + "static/knowledge-20294c3c4e76fb8facd2d8e7fbcb0353.svg";